import { MediaList, Layout } from '@/views/media';

export default {
    path: '/media',
    name: 'media',
    component: Layout,
    children: [
        { path: '', name: "media-list", component: MediaList },
    ]
};